import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import { Box, IconButton, useTheme } from "@mui/material";
import { Formik, Form } from "formik";
import StepperNavigation from "./StepperNavigation";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const MuiCustomStepper = (props) => {
  const { title, desc, children, snapshot, setSnapshot,isSubmitting, error } = props;
  const theme = useTheme();
  const steps = React.Children.toArray(children);
  const [stepNumber, setStepNumber] = useState(0);
  const step = steps[stepNumber];
  const totalSteps = steps.length;
  const isLastStep = stepNumber === totalSteps - 1;

  const handleNext = (values) => {
    setSnapshot((s) => ({
      ...s,
      ...values,
    }));
    setStepNumber((s) => s + 1);
  };

  const handlePrev = (values) => {
    setSnapshot((s) => ({
      ...s,
      ...values,
    }));
    setStepNumber((s) => s - 1);
  };

  const handleSubmit = async (values, { setTouched, setSubmitting }) => {
    if (step.props.onSubmit) {
      step.props.onSubmit(values, setSubmitting);
      return;
    }

    if (isLastStep) {
      return;
    } else {
      setTouched({});
      handleNext(values);
    }
  };

  return (
    <React.Fragment>
      <Box
        style={{
          width: "auto",
          height: "100vh",
          width: "100%",
        }}
      >
        <Paper
          sx={{
            mt: 3,
            mb: 3,
            padding: 2,
            background: theme.palette.background.main,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {props.onBack && (
              <IconButton onClick={stepNumber > 0 ? handlePrev : props.onBack}>
                <ArrowBackIcon />
              </IconButton>
            )}
            <Typography component="h1" variant="h4">
              {title}
            </Typography>
          </Box>
          <Typography textAlign={"center"} variant="subtitle1" sx={{ mt: 2 }}>
            {desc}
          </Typography>

          <Formik
            initialValues={snapshot}
            onSubmit={handleSubmit}
            validationSchema={step.props.validationSchema}
          >
            {(formik) => (
              <Form>
                <Stepper activeStep={stepNumber} sx={{ py: 5, px: 3 }}>
                  {steps.map((currenStep) => {
                    const label = currenStep.props.stepName;
                    return (
                      <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
                {step}

                <StepperNavigation
                  hasPrevious={stepNumber > 0}
                  isLastStep={isLastStep}
                  handlePrev={handlePrev}
                  handleSubmit={handleSubmit}
                  isSubmitting={formik.isSubmitting}
                  iss={isSubmitting}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    align="center"
                    variant="p"
                    sx={{ mb: 3, fontSize: 20, color: "red" }}
                  >
                    {error}
                  </Typography>
                </Box>
              </Form>
            )}
          </Formik>
        </Paper>
      </Box>
    </React.Fragment>
  );
};

export default MuiCustomStepper;
